import { useState } from "react";
import { toast } from "react-toastify";
import SalesService from "../../../../services/sales_service";

/**
 * useProfileModals
 * 
 * Responsabilidade única: gerenciar os estados e ações dos modais do perfil.
 * - Modal de Ações do Plano (MembershipActionsModal)
 * - Modal de Recibo Histórico (HistoricalReceiptModal)
 * 
 * @param {string} idTenant - ID do tenant para buscar dados do recibo
 */
const useProfileModals = (idTenant) => {

    // ─── Modal: Ações do Plano ───
    const [selectedMembership, setSelectedMembership] = useState(null);
    const [isActionsModalOpen, setIsActionsModalOpen] = useState(false);

    const handleViewMembershipDetails = (membership) => {
        setSelectedMembership(membership);
        setIsActionsModalOpen(true);
    };

    const toggleActionsModal = () => {
        setIsActionsModalOpen(!isActionsModalOpen);
        if (isActionsModalOpen) setSelectedMembership(null);
    };

    // ─── Modal: Recibo Histórico ───
    const [receiptModalOpen, setReceiptModalOpen] = useState(false);
    const [currentReceiptData, setCurrentReceiptData] = useState(null);

    const handlePrintReceipt = async (membership) => {
        if (!membership.idSale) {
            toast.info("Este contrato não possui uma venda vinculada.");
            return;
        }
        try {
            const sale = await SalesService.getById(idTenant, membership.idSale);
            if (sale) {
                setCurrentReceiptData(sale);
                setReceiptModalOpen(true);
            } else {
                toast.error("Venda originária não encontrada para este contrato.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Erro ao buscar detalhes do recibo.");
        }
    };

    const toggleReceiptModal = () => setReceiptModalOpen(false);

    return {
        // Ações do Plano
        selectedMembership,
        isActionsModalOpen,
        toggleActionsModal,
        handleViewMembershipDetails,

        // Recibo
        receiptModalOpen,
        currentReceiptData,
        toggleReceiptModal,
        handlePrintReceipt,
    };
};

export default useProfileModals;
